import React, { useState, useEffect, useRef, useCallback, useMemo, } from 'react';
import style from './DoctorDetail.module.css';
import HeadSub from '../../../../../components/comm/HeadSub';
import noDoctorImg from '../../../../../images/user/i_3d_hospital_inform_link_01.svg';
import noDoctorImgPngx2 from '../../../../../images/user/i_3d_hospital_inform_link_01x2.png';
import openWindowImg from '../../../../../images/common/i_open_window.svg';

import { useLocation, useNavigate } from 'react-router-dom';
import Skeleton from '@mui/material/Skeleton';

// tab
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

//Accordion
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import axiosApi from '../../../../../api/daonAxios';
import CODE from '../../../../../constants/code';

const DoctorDetail = () => {

    const location = useLocation();
    const navigate = useNavigate();

    // 초기 location.state 혹은 sessionStorage 값 불러오기
    const locationState = useMemo(() => {
        if (location.state) {
            sessionStorage.setItem(
                'doctorDetailState',
                JSON.stringify(location.state)
            );
            return location.state;
        }

        const saved = sessionStorage.getItem('doctorDetailState');
        return saved ? JSON.parse(saved) : {};
    }, [location.state]);

    const {
        deptCd = '',
        deptNm = '',
        hosptlCd = '',
        docName = '알수없음',
        doctNo = '',
        hosJbpt = "",
        schJbpt = "",
        etcJbpt = "",
        docField = "",
    } = locationState;

    const DoctorInfoParam = useMemo(
        () => ({
            hsptlCd: hosptlCd,
            deptCd: deptCd,
        }),
        [hosptlCd, deptCd]
    );

    const DoctorDetailInfoParam = useMemo(
        () => ({
            hsptlCd: hosptlCd,
            doctrNo: doctNo,
        }),
        [hosptlCd, doctNo]
    );

    const DoctorSchdulParam = useMemo(
        () => ({
            hsptlCd: hosptlCd,
            deptCd: deptCd,
            doctrNo: doctNo
        }),
        [hosptlCd, deptCd, doctNo]
    );

    //데이터 담기
    const [finderDoctor, setFinderDoctor] = useState(null);
    const [mvTcDoctrDetail, setMvTcDoctrDetail] = useState([]);
    const [doctrSchdulList, setDoctrSchdulList] = useState([]);

    //전송중 체크
    const isSendingRef = useRef(false);

    //로딩
    const [isLoading, setIsLoading] = useState(false);

    // 데이터 fetch 함수
    const fetchData = useCallback(async () => {
        if (isSendingRef.current) return;

        isSendingRef.current = true;
        setIsLoading(true);

        try {
            const [doctorList, doctorDetail, doctorSchdulList] = await Promise.all([
                axiosApi.post(
                    '/guide/doctr/retrieveDoctrList',
                    DoctorInfoParam
                ),
                axiosApi.post(
                    '/guide/doctr/retrieveDoctrDtlList',
                    DoctorDetailInfoParam
                ),
                axiosApi.post(
                    '/guide/doctr/retrieveDoctrSchdulList',
                    DoctorSchdulParam
                ),
            ]);

            if (doctorList.data.resultCode === CODE.RCV_SUCCESS) {

                const doctorLists = doctorList.data.result.doctrInfo;
                const filterDoctor = doctorLists.filter((doctor) => doctor.doctrNo === doctNo);

                setFinderDoctor(filterDoctor[0]);

            } else {
                setFinderDoctor([]);
            }

            if (doctorDetail.data.resultCode === CODE.RCV_SUCCESS) {
                setMvTcDoctrDetail(doctorDetail.data.result.doctrInfo);
            } else {
                setMvTcDoctrDetail([]);
            }

            if (doctorSchdulList.data.resultCode === CODE.RCV_SUCCESS) {

                const doctorSchduls = doctorSchdulList.data.result.doctrInfo;
                setDoctrSchdulList(doctorSchduls[0]);
            } else {
                setDoctrSchdulList([]);
            }
        } catch (err) {
            console.error('Error fetching doctor data:', err);
        } finally {
            isSendingRef.current = false;
            setIsLoading(false);
        }
    }, [DoctorInfoParam, DoctorDetailInfoParam, DoctorSchdulParam]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);


    //진료시간 
    const amSchdulList = doctrSchdulList && doctrSchdulList.amClnicYn ? doctrSchdulList.amClnicYn : '';
    const pmSchdulList = doctrSchdulList && doctrSchdulList.pmClnicYn ? doctrSchdulList.pmClnicYn : '';


    /* gbn 타입별  
    *
    *  ACDMCR == 학력  CAREER == 경력  SDYTRN == 연수  RLM == 연구분야   WNPZ == 수상이력  LRSTY ==학회활동  
    *  THESIS == 논문 BOOK == 저서 NEWS == 뉴스 VIDO == 영상
    * 
    */

    const filterEdu = mvTcDoctrDetail.filter((edu) => edu.gbn === "ACDMCR").filter((edu) => /[가-힣]/.test(edu.sj));  // 한글만 가져오기
    const filterCareer = mvTcDoctrDetail.filter((career) => career.gbn === "CAREER");
    const filterTraining = mvTcDoctrDetail.filter((training) => training.gbn === "SDYTRN");
    const filterResearch = mvTcDoctrDetail.filter((research) => research.gbn === "RLM");
    const filterAward = mvTcDoctrDetail.filter((award) => award.gbn === "WNPZ");
    const filterAcademic = mvTcDoctrDetail.filter((academic) => academic.gbn === "LRSTY");

    const filterDoctorsThesis = mvTcDoctrDetail.filter((doctor) => doctor.gbn === "THESIS");
    const filterDoctorsBook = mvTcDoctrDetail.filter((doctor) => doctor.gbn === "BOOK");
    const filterDoctorsNews = mvTcDoctrDetail.filter((doctor) => doctor.gbn === "NEWS");
    const filterDoctorsVido = mvTcDoctrDetail.filter((doctor) => doctor.gbn === "VIDO");


    const tabList = [
        {
            value: '1',
            label: '논문',
            data: filterDoctorsThesis,
            renderItem: (item, index) => (
                <li key={index}>
                    <p>{item.sj}</p>
                    <span>{item.authr}</span>
                    <div className={style['txt-group']}>
                        <span>{item.dt.replace(/-/g, '.')}</span>
                        <span>{item.instt}</span>
                    </div>
                </li>
            ),
        },
        {
            value: '2',
            label: '저서',
            data: filterDoctorsBook,
            renderItem: (item, index) => (
                <li key={index}>
                    <p>{item.sj}</p>
                    <span>{item.authr}</span>
                    <div className={style['txt-group']}>
                        <span>{item.dt.replace(/-/g, '.')}</span>
                        <span>{item.instt}</span>
                    </div>
                </li>
            ),
        },
        {
            value: '3',
            label: '뉴스',
            data: filterDoctorsNews,

            renderItem: (item, index) => {
                const match = item.sj.match(/\[([^\]]+)\]/);
                const title = match ? item.sj.replace(match[0], '') : item.sj;
                const badge = match ? match[1] : '';

                return (
                    <li key={index} onClick={() => openExternalUrl(item.instt)}>
                        <p>{title}</p>
                        <div className={style['txt-group']}>
                            <span>{item.dt.replace(/-/g, '.')}</span>
                            <span>{badge}</span>
                        </div>
                        <span className={style['open-window-btn']}>
                            <object data={openWindowImg} aria-hidden='true'></object>
                            <span className='blind'>새창바로가기</span>
                        </span>
                    </li>
                );
            },
        },
        {
            value: '4',
            label: '영상',
            data: filterDoctorsVido,

            renderItem: (item, index) => {
                const match = item.sj.match(/\[([^\]]+)\]/);
                const title = match ? item.sj.replace(match[0], '') : item.sj;
                const badge = match ? match[1] : '';

                return (
                    <li key={index} onClick={() => openExternalUrl(item.instt)}>
                        <p>{title}</p>
                        <div className={style['txt-group']}>
                            <span>{item.dt.replace(/-/g, '.')}</span>
                            <span>{badge}</span>
                        </div>
                        <span className={style['open-window-btn']}>
                            <object data={openWindowImg} aria-hidden='true'></object>
                            <span className='blind'>새창바로가기</span>
                        </span>
                    </li>
                );
            },
        },
    ];

    /* 탭 */
    const [value, setValue] = useState('1');

    useEffect(() => {
        const firstVisibleTab = tabList.filter(tab => tab.data.length > 0)[0];
        if (firstVisibleTab) {
            setValue(firstVisibleTab.value);
        }
    }, [mvTcDoctrDetail]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    function hospitalName(val) {
        var hosName = '';
        switch (val) {
            case '011':
                hosName = '여의도성모병원';
                break;
            case '012':
                hosName = '서울성모병원';
                break;
            case '013':
                hosName = '의정부성모병원';
                break;
            case '014':
                hosName = '부천성모병원';
                break;
            case '015':
                hosName = '은평성모병원';
                break;
            case '016':
                hosName = '인천성모병원';
                break;
            case '017':
                hosName = '성빈센트성모병원';
                break;
            case '018':
                hosName = '대전성모병원';
                break;
            default:
                hosName = '성모병원';
                break;
        }
        return hosName;
    }

    // 더보기 기능 
    const [visibleCount, setVisibleCount] = useState({
        '1': 5,
        '2': 5,
        '3': 5,
        '4': 5,
    });

    const handleLoadMore = (tabValue) => {
        setVisibleCount((prev) => ({
            ...prev,
            [tabValue]: prev[tabValue] + 5,
        }));
    };

    // DoctorDetail.jsx — 유틸 함수 추가
    const openExternalUrl = (url) => {
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'OPEN_EXTERNAL_URL',
                url: url
            }));
        } else {
            window.open(url, '_blank');
        }
    };

    return (
        <>
            <HeadSub title="상세 보기" />

            <div id="sub-content">
                <div className="inner-wrap" data-padding="0">

                    <div className={style['top-box']}>
                        <div className={style['profile-box']}>
                            <div className={style['profile-avatar']}>
                                {isLoading ? (
                                    <Skeleton
                                        variant="circular"
                                        animation="wave"
                                        height={100}
                                        width={100}
                                    />
                                ) : !finderDoctor ||
                                    !finderDoctor.doctrImgUrl ? (
                                    <div className={style['in-box']}>
                                        <object data={noDoctorImg} aria-hidden='true' />
                                    </div>
                                ) : (
                                    <div className={style['in-box']}>

                                        <img
                                            src={finderDoctor.doctrImgUrl}
                                            alt="Doctor"
                                            className="animation-3"
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = noDoctorImgPngx2;
                                            }}
                                        />
                                    </div>
                                )}
                            </div>
                            <div className={style['profile-txts']}>
                                <p className={style['top-txt']}>
                                    <span>{hospitalName(hosptlCd)}</span>
                                    <span>{deptNm}</span>
                                </p>
                                <p className={style['bom-txt']}>
                                    {docName} <span>{hosJbpt}</span>
                                </p>
                            </div>
                        </div>

                        <span className={style['line']}></span>

                        <div className={style['inform-fild']}>
                            <p>진료 분야</p>
                            <span>{docField}</span>
                        </div>
                        <div className={style['inform-hours']}>

                            <p>진료 시간</p>

                            <div className={style['inform-day']}>
                                <p>오전 진료</p>
                                <div className={style['day-lists']}>
                                    {isLoading ? (
                                        <Skeleton variant="text" height={18} width={40} />
                                    ) : amSchdulList && amSchdulList.length > 0 ? (
                                        amSchdulList.split(',').map((day, index) => (
                                            <span key={index} className='animation-3'>{day}</span>
                                        ))
                                    ) : (
                                        <p className='animation-3'>
                                            <span className={style['no-schdul']}></span>
                                        </p>
                                    )}
                                </div>
                            </div>
                            <div className={style['inform-day']}>
                                <p>오후 진료</p>
                                <div className={style['day-lists']}>
                                    {isLoading ? (
                                        <Skeleton variant="text" height={18} width={40} />
                                    ) : pmSchdulList && pmSchdulList.length > 0 ? (
                                        pmSchdulList.split(',').map((day, index) => (
                                            <span key={index} className='animation-3'>{day}</span>
                                        ))
                                    ) : (
                                        <p className='animation-3'>
                                            <span className={style['no-schdul']}></span>
                                        </p>

                                    )}
                                </div>
                            </div>

                            <span className={style['reference-txt']}>
                                진료 일정은 변경될 수 있습니다.
                            </span>
                        </div>

                        {/* 상세 정보 ::S */}
                        <div className={style['detail-inform']}>
                            <p>상세 정보</p>

                            <div className="accordion-wrap" data-type="c">

                                {/* 직위 */}
                                <Accordion defaultExpanded>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1-content"
                                        id="panel1-header"
                                    >
                                        <div className="accordion-head">
                                            <p className="tit">직위</p>
                                        </div>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <div className="accordion-body">
                                            <div
                                                className="table-box"
                                                data-table-type="under-line"
                                                data-style="a"
                                            >
                                                <table>
                                                    <colgroup>
                                                        <col width={'80'} />
                                                        <col width={'auto'} />
                                                    </colgroup>
                                                    <tbody>
                                                        <tr>
                                                            <th>병원</th>
                                                            <td>{hosJbpt}</td>
                                                        </tr>
                                                        {schJbpt && (
                                                            <tr>
                                                                <th>학교</th>
                                                                <td>{schJbpt}</td>
                                                            </tr>
                                                        )}
                                                        {etcJbpt && (
                                                            <tr>
                                                                <th>기타</th>
                                                                <td>{etcJbpt}</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </AccordionDetails>
                                </Accordion>

                                {/* 학위 */}
                                {filterEdu.length > 0 && (
                                    <Accordion defaultExpanded>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1-content"
                                            id="panel1-header"
                                        >
                                            <div className="accordion-head">
                                                <p className="tit">
                                                    학력
                                                </p>
                                            </div>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <div className="accordion-body">
                                                <div className='table-box' data-table-type="under-line" data-style="a">
                                                    <table>
                                                        <colgroup>
                                                            <col width={"80"} />
                                                            <col width={"auto"} />
                                                        </colgroup>
                                                        <tbody>

                                                            {isLoading ? (
                                                                Array.from({ length: 2 }).map((_, index) => (
                                                                    <tr key={index} className={style['skeleton-list']}>
                                                                        <th> <Skeleton variant="text" height={24} width={40} /></th>
                                                                        <td> <Skeleton variant="text" height={24} width={'80%'} /></td>
                                                                    </tr>
                                                                ))
                                                            ) : filterEdu.length > 0 ? (
                                                                filterEdu.map((edu, i) => (
                                                                    <tr key={i}>
                                                                        {edu.dt === "~" ? (
                                                                            <>
                                                                                <th></th>
                                                                                <td>{edu.sj}</td>
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <th>{edu.dt}</th>
                                                                                <td>{edu.sj}</td>
                                                                            </>
                                                                        )}
                                                                    </tr>

                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <th colSpan={2}>정보가 없습니다.</th>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </AccordionDetails>
                                    </Accordion>
                                )}

                                {/* 경력 */}
                                {filterCareer.length > 0 && (
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1-content"
                                            id="panel1-header"
                                        >
                                            <div className="accordion-head">
                                                <p className="tit">
                                                    경력
                                                </p>
                                            </div>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <div className="accordion-body">
                                                <div className='table-box' data-table-type="under-line" data-style="a">
                                                    <table>
                                                        <colgroup>
                                                            <col width={"80"} />
                                                            <col width={"auto"} />
                                                        </colgroup>
                                                        <tbody>
                                                            {isLoading ? (
                                                                Array.from({ length: 2 }).map((_, index) => (
                                                                    <tr key={index} className={style['skeleton-list']}>
                                                                        <th> <Skeleton variant="text" height={24} width={40} /></th>
                                                                        <td> <Skeleton variant="text" height={24} width={'80%'} /></td>
                                                                    </tr>
                                                                ))
                                                            ) : filterCareer.length > 0 ? (
                                                                filterCareer.map((career, i) => (
                                                                    <tr key={i}>
                                                                        {career.dt === "~" ? (
                                                                            <td colSpan={2}>{career.sj}</td>
                                                                        ) : (
                                                                            <>
                                                                                <th>{career.dt}</th>
                                                                                <td>{career.sj}</td>
                                                                            </>
                                                                        )}
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <th colSpan={2}>정보가 없습니다.</th>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </AccordionDetails>
                                    </Accordion>
                                )}

                                {/* 연수 */}
                                {filterTraining.length > 0 && (
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1-content"
                                            id="panel1-header"
                                        >
                                            <div className="accordion-head">
                                                <p className="tit">
                                                    연수
                                                </p>
                                            </div>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <div className="accordion-body">
                                                <div className='table-box' data-table-type="under-line" data-style="a">
                                                    <table>
                                                        <colgroup>
                                                            <col width={"80"} />
                                                            <col width={"auto"} />
                                                        </colgroup>
                                                        <tbody>
                                                            {isLoading ? (
                                                                Array.from({ length: 2 }).map((_, index) => (
                                                                    <tr key={index} className={style['skeleton-list']}>
                                                                        <th> <Skeleton variant="text" height={24} width={40} /></th>
                                                                        <td> <Skeleton variant="text" height={24} width={'80%'} /></td>
                                                                    </tr>
                                                                ))
                                                            ) : filterTraining.length > 0 ? (
                                                                filterTraining.map((training, i) => (
                                                                    <tr key={i}>
                                                                        {training.dt === "~" ? (
                                                                            <td colSpan={2}>{training.sj}</td>
                                                                        ) : (
                                                                            <>
                                                                                <th>{training.dt}</th>
                                                                                <td>{training.sj}</td>
                                                                            </>
                                                                        )}
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <th colSpan={2}>정보가 없습니다.</th>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </AccordionDetails>
                                    </Accordion>
                                )}

                                {/* 연구분야 */}
                                {filterResearch.length > 0 && (
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1-content"
                                            id="panel1-header"
                                        >
                                            <div className="accordion-head">
                                                <p className="tit">
                                                    연구분야
                                                </p>
                                            </div>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <div className="accordion-body">
                                                <div className='table-box' data-table-type="under-line" data-style="a">
                                                    <table>
                                                        <colgroup>
                                                            <col width={"80"} />
                                                            <col width={"auto"} />
                                                        </colgroup>
                                                        <tbody>
                                                            {isLoading ? (
                                                                Array.from({ length: 2 }).map((_, index) => (
                                                                    <tr key={index} className={style['skeleton-list']}>
                                                                        <th> <Skeleton variant="text" height={24} width={40} /></th>
                                                                        <td> <Skeleton variant="text" height={24} width={'80%'} /></td>
                                                                    </tr>
                                                                ))
                                                            ) : filterResearch.length > 0 ? (
                                                                filterResearch.map((research, i) => (
                                                                    <tr key={i}>
                                                                        {research.dt === "~" ? (
                                                                            <td colSpan={2}>{research.sj}</td>
                                                                        ) : (
                                                                            <td colSpan={2}>{research.sj}</td>
                                                                        )}
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <th colSpan={2}>정보가 없습니다.</th>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </AccordionDetails>
                                    </Accordion>
                                )}

                                {/* 수상이력 */}
                                {filterAward.length > 0 && (
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1-content"
                                            id="panel1-header"
                                        >
                                            <div className="accordion-head">
                                                <p className="tit">
                                                    수상이력
                                                </p>
                                            </div>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <div className="accordion-body">
                                                <div className='table-box' data-table-type="under-line" data-style="a">
                                                    <table>
                                                        <colgroup>
                                                            <col width={"80"} />
                                                            <col width={"auto"} />
                                                        </colgroup>
                                                        <tbody>
                                                            {isLoading ? (
                                                                Array.from({ length: 2 }).map((_, index) => (
                                                                    <tr key={index} className={style['skeleton-list']}>
                                                                        <th> <Skeleton variant="text" height={24} width={40} /></th>
                                                                        <td> <Skeleton variant="text" height={24} width={'80%'} /></td>
                                                                    </tr>
                                                                ))
                                                            ) : filterAward.length > 0 ? (
                                                                filterAward.map((award, i) => (
                                                                    <tr key={i}>
                                                                        {award.dt === "~" ? (
                                                                            <td colSpan={2}>{award.sj}</td>
                                                                        ) : (
                                                                            <>
                                                                                <th className='text-align-center'>{award.dt.split("~")[0].trim()}</th>
                                                                                <td>{award.sj}</td>
                                                                            </>
                                                                        )}
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <th colSpan={2}>정보가 없습니다.</th>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </AccordionDetails>
                                    </Accordion>
                                )}

                                {/* 학회활동 */}
                                {filterAcademic.length > 0 && (
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1-content"
                                            id="panel1-header"
                                        >
                                            <div className="accordion-head">
                                                <p className="tit">
                                                    학회활동
                                                </p>
                                            </div>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <div className="accordion-body">
                                                <div className='table-box' data-table-type="under-line" data-style="a">
                                                    <table>
                                                        <colgroup>
                                                            <col width={"80"} />
                                                            <col width={"auto"} />
                                                        </colgroup>
                                                        <tbody>
                                                            {isLoading ? (
                                                                Array.from({ length: 2 }).map((_, index) => (
                                                                    <tr key={index} className={style['skeleton-list']}>
                                                                        <th> <Skeleton variant="text" height={24} width={40} /></th>
                                                                        <td> <Skeleton variant="text" height={24} width={'80%'} /></td>
                                                                    </tr>
                                                                ))
                                                            ) : filterAcademic.length > 0 ? (
                                                                filterAcademic.map((academic, i) => (
                                                                    <tr key={i}>
                                                                        {academic.dt === "~" ? (
                                                                            <td colSpan={2}>{academic.sj}</td>
                                                                        ) : (
                                                                            <>
                                                                                <th>{academic.dt}</th>
                                                                                <td>{academic.sj}</td>
                                                                            </>
                                                                        )}
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <th colSpan={2}>정보가 없습니다.</th>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </AccordionDetails>
                                    </Accordion>
                                )}
                            </div>
                        </div>
                        {/* 상세 정보 ::E */}
                    </div>


                    <div
                        className={style['tab-header-box']}
                        data-margin-left="0"
                    >
                        <TabContext value={value}>
                            <TabList
                                onChange={handleChange}
                                aria-label="lab API tabs example"
                                variant="scrollable"
                                scrollButtons={false}
                                className={style['tab-title-box']}
                            >
                                {tabList
                                    .filter(tab => tab.data.length > 0)
                                    .map((tab) => (
                                        <Tab key={tab.value} label={tab.label} value={tab.value} disableRipple />
                                    ))}
                            </TabList>


                            {tabList.filter(tab => tab.data.length > 0)
                                .map((tab) => (
                                    <TabPanel key={tab.value} value={tab.value}>
                                        <div className={style['list-item-wrap']}>
                                            <div className={style['list-item-box']}>
                                                <ul>
                                                    {isLoading ? (
                                                        Array.from({ length: 2 }).map((_, index) => (
                                                            <li key={index} className={style['skeleton-list']}>
                                                                <p> <Skeleton variant="text" height={24} width={'80%'} /></p>
                                                                <p> <Skeleton variant="text" height={24} width={50} /></p>
                                                                <p> <Skeleton variant="text" height={24} width={100} /></p>
                                                            </li>
                                                        ))
                                                    ) : tab.data.length > 0 ? (
                                                        <>
                                                            {tab.data.slice(0, visibleCount[tab.value]).map(tab.renderItem)}

                                                            {visibleCount[tab.value] < tab.data.length && (
                                                                <li className={style['load-more-btn']}>
                                                                    <span onClick={() => handleLoadMore(tab.value)}>더 보기</span>
                                                                </li>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <li className={style['no-data']}>
                                                            <p>{tab.label} 정보가 없습니다.</p>
                                                        </li>
                                                    )}
                                                </ul>
                                            </div>
                                        </div>
                                    </TabPanel>
                                ))}
                        </TabContext>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DoctorDetail;
